import { css } from 'linaria';

export const stretchBannerAdLabelStyles = css`
  position: absolute;
  right: var(--space-200);
  display: flex;
  gap: var(--space-225);

  @media (--only-mobile) {
    gap: var(--space-125);
    right: var(--space-125);
  }
`;
